import anime from "animejs/lib/anime.es.js";
import Swiper, { Scrollbar, Mousewheel, Lazy, Controller } from "swiper";
Swiper.use([Scrollbar, Mousewheel, Lazy, Controller]);

import swiperClasses from "../util/swiperClasses";
import breakpoints from "../util/breakpoints";

export default class CarouselHover {
  constructor() {
    this.carousel = "";
    this.carouselInit = false;
  }

  init() {
    this.setupSlider();
  }

  events() {
    window.addEventListener("resize", throttle(this.setupSlider, 300));
  }

  setupSlider() {
    if (breakpoints.small.matches) {
      if (!this.carouselInit) {
        this.carouselInit = true;
        this.carousel = new Swiper(".o-carousel.--hover", {
          loop: false,
          slidesPerView: "auto",
          scrollbar: {
            el: ".o-carousel-scrollbar",
            hide: false,
          },
          ...swiperClasses,
        });
      }
    } else {
      if (this.carousel) {
        this.carousel.destroy();
      }
      this.carouselInit = false;

      $(".o-carousel.--hover .o-carousel-slide").on("mouseover", function() {
        let index = $(this).index();
        anime({
          targets: ".o-carousel-scrollbar.--hover .o-carousel-scrollbar-drag",
          translateX: index * 100 + "%",
          easing: "easeOutQuint",
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/carouselHover.js